import { PersonType } from "../../types"

export const personTypes: { [key in PersonType]: string } = {
  "PHYSICAL": "Física",
  "MORAL": "Moral"
};
